import { fromDotObject } from "../../utils/dotObject";
import updateDocumentData from "../../utils/updateDocumentData";

import { Organization } from "./types/Organization";

export default function updateOrganization(firebase, ref, data) {
	return ref.set(Organization.partial().parse(updateDocumentData(firebase, fromDotObject(data))), { merge: true });
}
